import React, { useState, useEffect } from "react";
// @material-ui/core components
import { Grid, Tabs, Tab } from "@material-ui/core";
// @material-ui/styles
import { makeStyles } from "@material-ui/core/styles";
import tableStyles from "../../../../assets/jss/components/tableStyle";
import styles from "../../../../assets/jss/layouts/appStyle";
// core components
import { LOCALE } from "../../../../properties/Locale";
import TrainingOrganizerComponent from "./trainingOrganizer/TrainingOrganizerComponent";
import TrainingHourRangeComponent from "./trainingHourRange/TrainingHourRangeComponent";
import TrainingRoleComponent from "./trainingRole/TrainingRoleComponent";
import TrainingSchemaPointComponent from "./trainingSchemaPoint/TrainingSchemaPointComponent";

const useStyles = makeStyles(styles, tableStyles);

export default function TrainingConfigComponent(props) {
  const classes = useStyles();
  const [tabIndex, setTabIndex] = useState(0);

  const handleTabChange = (event, newTabIndex) => {
    setTabIndex(newTabIndex);
  };

  return (
    <div>
      <Grid container style={{ paddingTop: "25px" }}>
        <Tabs
          value={tabIndex}
          onChange={handleTabChange}
          indicatorColor="primary"
          textColor="primary"
        >
          <Tab label={LOCALE.training_organizer} />
          <Tab label={LOCALE.training_role} />
          <Tab label={LOCALE.training_hour_range} />
          <Tab label={LOCALE.schema_points} />
        </Tabs>
        {tabIndex === 0 && (
          <TrainingOrganizerComponent gradingSchemaId={props.gradingSchemaId} />
        )}
        {tabIndex === 1 && (
          <TrainingRoleComponent gradingSchemaId={props.gradingSchemaId} />
        )}
        {tabIndex === 2 && (
          <TrainingHourRangeComponent gradingSchemaId={props.gradingSchemaId} />
        )}
        {tabIndex === 3 && (
          <TrainingSchemaPointComponent
            gradingSchemaId={props.gradingSchemaId}
          />
        )}
      </Grid>
    </div>
  );
}
